import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineSearch } from "react-icons/md";
import { Button, Spinner } from "react-bootstrap";
import { Inputs } from "../index";
import { Alert, useBalloonsV2, useScreenSize, useAddSearchedTerm } from "../../utils";
import style from "./SearchBar.module.css";
import { useAppContext } from "../../context";
import { serverTimestamp } from "firebase/firestore";

const SearchBar = ({
  setFilteredBalloons,
  setResults,
  setLastValidResults,
  lastSearch,
  setLastSearch,
}) => {
  const { t } = useTranslation();
  const screenSize = useScreenSize();
  const { data: balloonsData, isLoading: loadingBalloons } = useBalloonsV2();
  const [searchValue, setSearchValue] = useState("");
  const [searchTriggered, setSearchTriggered] = useState(false);
  
  const {user} = useAppContext();
  const addSearchedTerm = useAddSearchedTerm();

  useEffect(() => {
    if (!searchTriggered) return;

    if (!lastSearch.trim()) {
      Alert.error(
        t("No results found. Try a different term or adjust your filters.")
      );
      setFilteredBalloons([]);
      setResults && setResults([]);
      setLastValidResults([]);
      setSearchTriggered(false);
      return;
    }

    const newFilteredBalloons = balloonsData?.filter((balloon) => {
      // Dividimos la búsqueda en palabras clave
      const searchTerms = lastSearch.toLowerCase().trim().split(/\s+/);
      return searchTerms.every((term) => {
        // Expresión regular para buscar la palabra completa
        const regex = new RegExp(`\\b${term}\\b`, "i");

        // Comparamos cada término con las propiedades relevantes
        const nameMatch = regex.test(balloon.name?.toLowerCase() || "");
        const displayNameMatch = regex.test(
          balloon.displayName?.toLowerCase() || ""
        );
        const colorCategoriesMatch = (balloon.colorCategories ?? []).some(
          (category) => regex.test(category?.toLowerCase() || "")
        );

        const brandMatch = balloon.combined
          ? regex.test(balloon.insideBrand?.toLowerCase() || "") ||
            regex.test(balloon.outsideBrand?.toLowerCase() || "")
          : regex.test(balloon.brand?.toLowerCase() || "");

        // El globo solo se muestra si TODOS los términos están en alguna propiedad
        return (
          nameMatch || displayNameMatch || colorCategoriesMatch || brandMatch
        );
      });
    });
    setFilteredBalloons(newFilteredBalloons);
    if (!lastSearch || !newFilteredBalloons?.length) {
      Alert.error(
        t("No results found. Try a different term or adjust your filters.")
      );
    }

    setResults && setResults(newFilteredBalloons);
    setLastValidResults(newFilteredBalloons);
    setSearchTriggered(false); // Reinicia el estado para futuras búsquedas
  }, [
    lastSearch,
    searchTriggered,
    balloonsData,
    setFilteredBalloons,
    setLastValidResults,
    setResults,
    t,
  ]);

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const handleOnClickSearch = () => {
    if (loadingBalloons) return Alert.error("Balloons still loading");
    setLastSearch(searchValue.trim().toLowerCase().replace(/-/g, ''));
    setSearchTriggered(true); // Indicamos que la búsqueda debe ejecutarse

    if (
      (user && 
      user.email !== process.env.REACT_APP_ADMIN1_EMAIL &&
      user.email !== process.env.REACT_APP_ADMIN2_EMAIL &&
      user.email !== process.env.REACT_APP_ADMIN3_EMAIL &&
      user.email !== process.env.REACT_APP_ADMIN4_EMAIL &&
      user.email !== process.env.REACT_APP_ADMIN5_EMAIL &&
      user.email !== process.env.REACT_APP_ADMIN6_EMAIL &&
      user.email !== process.env.REACT_APP_ADMIN7_EMAIL
      ) || !user
    ) {
      try {
        const searchTermToSend = {
          user: user ? user.email : 'Guest',
          term: searchValue.trim().toLowerCase(),
          searchedAt: serverTimestamp(),
        };
        //console.log({ searchTermToSend });
        addSearchedTerm.mutate(searchTermToSend);
      } catch (error) {
        console.log(error);
      }
    }

  };

  return (
    <Inputs.FormControl
      value={searchValue}
      onChange={handleSearch}
      customClass={style.searchBarLabel}
      className={style.searchBar}
      icon={screenSize > 992 && <MdOutlineSearch />}
      placeholder={t("Search by balloon color or brand...")}
      size="lg"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleOnClickSearch();
        }
      }}
      decoration={
        // <>
        <Button
          variant="light"
          className={style.searchBtn}
          onClick={handleOnClickSearch}
          size="md"
        >
          {screenSize > 992 ? (
            loadingBalloons ? (
              <Spinner animation="border" size="sm" />
            ) : (
              t("SEARCH")
            )
          ) : (
            <MdOutlineSearch size="1.5rem" />
          )}
        </Button>
        // {lastSearch && (
        //   <Button
        //     variant="light"
        //     className={style.searchBtn}
        //     onClick={handleReset}
        //     size="md"
        //   >
        //     <MdOutlineRefresh size="1.5rem" />
        //   </Button>
        // )}
        // </>
      }
    />
  );
};

export default SearchBar;
